import { db } from "./firebaseConfig";
import { collection, addDoc } from "firebase/firestore";

const IngresoStCabDB = async ({
    folio,
    rut,
    entidad,
    telefono,
    direccion,
    correo,
    date,
    nacim,
    confirmado,
    estado,
    estado_servicio,
    fecha_out,
    familia,
    tipo,
    marca,
    modelo,
    serie,
    servicio,
    servicionew,
    observaciones,
    horamaquina,
    tecnico,
    userAdd,
    userMod,
    fechaAdd,
    fechaMod,
    fecha_servicionew,
    emp_id,

    // TRAZABILIDAD DESDE HOMECARE
    origen_ingreso = "",
    emp_id_origen = "",
    id_traspaso = "",
    eq_id_origen = "",
    id_mantencion = "",
    rut_paciente = "",
    paciente = "",
}) => {

    return await addDoc(
        collection(db, "ingresostcab"),
        {
            folio,
            rut,
            entidad,
            telefono,
            direccion,
            correo,

            date,
            fnaci: nacim,

            confirmado,
            estado,
            estado_servicio,
            fecha_out,

            familia,
            tipo,
            marca,
            modelo,
            serie,

            servicio,
            servicionew,
            fecha_servicionew,

            observaciones,
            horamaquina,
            tecnico,

            boleta: null,
            monto: null,
            motivo: null,

            useradd: userAdd,
            usermod: userMod,
            fechaadd: fechaAdd,
            fechamod: fechaMod,

            emp_id,

            // =========================
            // TRAZABILIDAD HOMECARE
            // =========================

            origen_ingreso,
            emp_id_origen,
            id_traspaso,
            eq_id_origen,
            id_mantencion,
            rut_paciente,
            paciente,
        }
    );
};

export default IngresoStCabDB;